import { QuantifyChartProps } from '@modules/quantify/components/QuantifyChart/QuantifyChart';
import { useFetchQuantifyReport } from '@modules/quantify/hooks';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { Paper, Stack } from '@mui/material';
import { useState } from 'react';
import { useUpdateEffect } from 'react-use';
import { QuantifyChart } from '../QuantifyChart';
import { QuantifyReportToolbar } from '../QuantifyReportToolbar';
import { QuantifyTemplates } from '../QuantifyTemplates';

interface QuantifyChartWidgetProps {
  quantifyChartProps?: QuantifyChartProps;
  shouldHideTemplates?: boolean;
}

export function QuantifyChartWidget({
  quantifyChartProps,
  shouldHideTemplates,
}: QuantifyChartWidgetProps) {
  const shouldShowTemplates = useQuantifyStore(({ query }) =>
    shouldHideTemplates !== undefined
      ? !shouldHideTemplates
      : !query.groupByField,
  );
  const fetchQuantifyReport = useFetchQuantifyReport();
  const [shouldFetchReportData, setShouldFetchReportData] = useState(false);

  useUpdateEffect(() => {
    if (shouldFetchReportData) {
      fetchQuantifyReport();
      // Required to enable data fetch for next selections
      setShouldFetchReportData(false);
    }
  }, [shouldFetchReportData]);

  const onExampleSelect = () => {
    setShouldFetchReportData(true);
  };

  const renderContent = () => {
    if (shouldShowTemplates) {
      return <QuantifyTemplates onExampleSelect={onExampleSelect} />;
    }

    return (
      <Paper
        variant="outlined"
        sx={{
          borderRadius: 2,
        }}
      >
        <QuantifyChart isQuantifyPageView {...quantifyChartProps} />
      </Paper>
    );
  };

  return (
    <Stack spacing={1} data-role="quantify-chart-widget">
      <QuantifyReportToolbar />
      {renderContent()}
    </Stack>
  );
}
